import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

//getSettingPageDetails
export const getSettingPageDetails = createAsyncThunk('settingsSlice/getSettingPageDetails', async () => {
  const response = await axios.get(`/getsettings`, {
    headers: {
      ApiKey: window.globalConfig.API_KEY,
    },
  });
  return response.data;
});
//getOverrideGlobalStatus
export const getOverrideGlobalStatus = createAsyncThunk('settingsSlice/getOverrideGlobalStatus', async (value) => {
  const response = await axios.get(`/getoverridesettings?domainId=${Number(value)}`, {
    headers: {
      ApiKey: window.globalConfig.API_KEY,
    },
  });
  return response.data;
});
//getOverrideGlobalStatusforloginUser
export const getOverrideGlobalStatusforloginUser = createAsyncThunk(
  'settingsSlice/getOverrideGlobalStatusforloginUser',
  async (value) => {
    const domainId = Number(localStorage.getItem('domainId'));
    const response = await axios.get(`/getoverridesettings?domainId=${domainId}`, {
      headers: {
        ApiKey: window.globalConfig.API_KEY,
      },
    });
    return response.data;
  }
);

//updateOverrideGlobalStatus
export const updateOverrideGlobalStatus = createAsyncThunk('settingsSlice/updateOverrideGlobalStatus', async (data) => {
  try {
    const response = await axios.post(`/overridesettings`, data);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});
//getDomainSettingPageDetailsforloginUser
export const getDomainSettingPageDetailsforloginUser = createAsyncThunk(
  'settingsSlice/getDomainSettingPageDetailsforloginUser',
  async (value) => {
    const response = await axios.get(`/DomainSettings/getdomainsettings?domainId=${value}`, {
      headers: {
        ApiKey: window.globalConfig.API_KEY,
      },
    });
    return response.data;
  }
);
//getDomainSettingPageDetails
export const getDomainSettingPageDetails = createAsyncThunk(
  'settingsSlice/getDomainSettingPageDetails',
  async (value) => {
    const response = await axios.get(`/DomainSettings/getdomainsettings?domainId=${value}`);
    return response.data;
  }
);
//getPortalAdminRights
export const getPortalAdminRights = createAsyncThunk('settingsSlice/getPortalAdminRights', async () => {
  const response = await axios.get(`/getportaladminrights`, {
    headers: {
      ApiKey: window.globalConfig.API_KEY,
    },
  });
  return response.data;
});
//getOuAdminRights
export const getOuAdminRights = createAsyncThunk('settingsSlice/getOuAdminRights', async () => {
  const response = await axios.get(`/getouadminrights`, {
    headers: {
      ApiKey: window.globalConfig.API_KEY,
    },
  });
  return response.data;
});
//updateSettingPage
export const updateSettingPage = createAsyncThunk('settingsSlice/updateSettingPage', async (data) => {
  try {
    const response = await axios.put(`/settings`, data);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err.message;
  }
});
//updateDomainSettings
export const updateDomainSettings = createAsyncThunk('settingsSlice/updateDomainSettings', async (data) => {
  try {
    const response = await axios.post(`/DomainSettings/domainsettings`, data);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});
export const updateDomainExportAttribute = createAsyncThunk(
  'settingsSlice/updateDomainExportAttribute',
  async (data) => {
    try {
      const response = await axios.put(`/ExportSettings/exportattributes`, data);
      return { status: response.status, data: response.data };
    } catch (err) {
      return { status: err.response.status, data: err.response.data };
    }
  }
);
export const getDomainExportAttribute = createAsyncThunk('settingsSlice/getDomainExportAttribute', async (data) => {
  try {
    const response = await axios.get(`/ExportSettings/getexportattributes?domainId=${data}`);
    return { status: response.status, data: response.data };
  } catch (err) {
    return { status: err.response.status, data: err.response.data };
  }
});

const initialState = {
  SettingsDataloading: false,
  SettingsData: null,
  SettingsDataerror: null,
  forgetPassword: true,
  rememberMeSetting: true,
  userProfileSetting: true,
  changePassword: true,
  passwordRuleEmail: true,
  passwordRuleUsername: true,
  upnAsEmail: null,
  portalAdminRightsloading: null,
  portalAdminRights: null,
  portalAdminRightserror: null,
  ouAdminRightsloading: null,
  ouAdminRights: null,
  ouAdminRightserror: null,
  mailUserCreation: true,
  mailResetPassword: true,
  mailUnlockUser: true,
  mailEnableUser: true,
  mailDisableUser: true,
  passwordGenerationSpecialCharacters: true,
  passwordGenerationAlphabets: true,
  passwordGenerationNumbers: true,
  domainPasswordGenerationSpecialCharacters: true,
  domainPasswordGenerationAlphabets: true,
  domainPasswordGenerationNumbers: null,
  domainMailUserCreation: true,
  domainMailResetPassword: true,
  domainMailUnlockUser: true,
  domainMailEnableUser: true,
  domainMailDisableUser: true,
  domainSettingsDataloading: false,
  domainSettingsData: null,
  domainSettingsDataerror: null,
  domainForgetPassword: true,
  domainRememberMeSetting: true,
  domainUserProfileSetting: true,
  domainChangePassword: true,
  domainPasswordRuleEmail: true,
  domainPasswordRuleUsername: true,
  domainUpnAsEmail: null,
  overrideGlobalStatus: null,
  overrideGlobalStatusError: null,
  overrideGlobalStatusUser: null,
  overrideGlobalStatusUserError: null,
  domainsettingsDataUser: null,
  domainsettingsUserError: null,
  domainExportAttributeLoader: false,
  domainExportAttributeData: [],
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getSettingPageDetails.pending, (state) => {
        state.SettingsDataloading = true;
      })
      .addCase(getSettingPageDetails.fulfilled, (state, action) => {
        state.SettingsDataloading = false;
        state.SettingsData = action.payload;
        if (action.payload) {
          state.forgetPassword = action.payload.forgotPassword;
          state.rememberMeSetting = action.payload.rememberMe;
          state.userProfileSetting = action.payload.userProfile;
          state.changePassword = action.payload.changePassword;
          state.passwordRuleEmail = action.payload.email;
          state.passwordRuleUsername = action.payload.userName;
          state.upnAsEmail = action.payload.useUpnAsEmail;
          state.accessToken = action.payload.accessToken !== 0 ? action.payload.accessToken : 600;
          state.linkExpiry = action.payload.linkExpiry !== 0 ? action.payload.linkExpiry : 1440;
          state.mailUserCreation = action.payload.mailUserCreation;
          state.mailResetPassword = action.payload.mailResetPassword;
          state.mailUnlockUser = action.payload.mailUnlockUser;
          state.mailEnableUser = action.payload.mailEnableUser;
          state.mailDisableUser = action.payload.mailDisableUser;
          state.passwordGenerationSpecialCharacters = action.payload.passwordGenerationSpecialCharacters;
          state.passwordGenerationAlphabets = action.payload.passwordGenerationAlphabets;
          state.passwordGenerationNumbers = action.payload.passwordGenerationNumbers;
          state.passwordGenerationLength =
            action.payload.passwordGenerationLength !== 0 ? action.payload.passwordGenerationLength : 12;
        }
        state.SettingsDataerror = null;
      })
      .addCase(getSettingPageDetails.rejected, (state, action) => {
        state.SettingsDataloading = false;
        state.SettingsData = null;
        state.SettingsDataerror = action.error.message;
      })
      .addCase(getDomainSettingPageDetails.pending, (state) => {
        state.domainSettingsDataloading = true;
        state.domainSettingsData = null;
        state.domainSettingsDataerror = null;
      })
      .addCase(getDomainSettingPageDetails.fulfilled, (state, action) => {
        state.domainSettingsDataloading = false;
        if (action.payload) {
          state.domainSettingsData = action.payload;
          state.domainUserProfileSetting = action.payload.userProfile;
          state.domainChangePassword = action.payload.changePassword;
          state.domainPasswordRuleEmail = action.payload.email;
          state.domainPasswordRuleUsername = action.payload.userName;
          state.domainUpnAsEmail = action.payload.useUpnAsEmail;
          state.domainMailUserCreation = action.payload.mailUserCreation;
          state.domainMailResetPassword = action.payload.mailResetPassword;
          state.domainMailUnlockUser = action.payload.mailUnlockUser;
          state.domainMailEnableUser = action.payload.mailEnableUser;
          state.domainMailDisableUser = action.payload.mailDisableUser;
          state.domainPasswordGenerationSpecialCharacters = action.payload.passwordGenerationSpecialCharacters;
          state.domainPasswordGenerationAlphabets = action.payload.passwordGenerationAlphabets;
          state.domainPasswordGenerationNumbers = action.payload.passwordGenerationNumbers;
        }
        state.domainSettingsDataerror = null;
      })
      .addCase(getDomainSettingPageDetails.rejected, (state, action) => {
        state.domainSettingsDataloading = false;
        state.domainSettingsData = null;
        state.domainUserProfileSetting = initialState.domainUserProfileSetting;
        state.domainChangePassword = initialState.domainChangePassword;
        state.domainPasswordRuleEmail = initialState.domainPasswordRuleEmail;
        state.domainPasswordRuleUsername = initialState.domainPasswordRuleUsername;
        state.domainUpnAsEmail = initialState.domainUpnAsEmail;
        state.domainMailUserCreation = initialState.domainMailUserCreation;
        state.domainMailResetPassword = initialState.domainMailResetPassword;
        state.domainMailUnlockUser = initialState.domainMailUnlockUser;
        state.domainMailEnableUser = initialState.domainMailEnableUser;
        state.domainMailDisableUser = initialState.domainMailDisableUser;
        state.domainPasswordGenerationSpecialCharacters = initialState.domainPasswordGenerationSpecialCharacters;
        state.domainPasswordGenerationAlphabets = initialState.domainPasswordGenerationAlphabets;
        state.domainPasswordGenerationNumbers = initialState.domainPasswordGenerationNumbers;
        state.domainSettingsDataerror = action.error.message;
      })
      .addCase(getDomainSettingPageDetailsforloginUser.fulfilled, (state, action) => {
        if (action.payload) {
          state.domainsettingsDataUser = action.payload;
        }
        state.domainsettingsUserError = null;
      })
      .addCase(getDomainSettingPageDetailsforloginUser.rejected, (state, action) => {
        state.domainsettingsDataUser = null;
        state.domainsettingsUserError = action.error.message;
      })
      .addCase(getOverrideGlobalStatus.fulfilled, (state, action) => {
        if (action.payload) {
          state.overrideGlobalStatus = action.payload;
          state.overrideGlobalStatusError = null;
        }
      })
      .addCase(getOverrideGlobalStatus.rejected, (state, action) => {
        state.overrideGlobalStatus = null;
        state.overrideGlobalStatusError = action.error.message;
      })
      .addCase(getOverrideGlobalStatusforloginUser.fulfilled, (state, action) => {
        if (action.payload) {
          state.overrideGlobalStatusUser = action.payload;
          state.overrideGlobalStatusUserError = null;
        }
      })
      .addCase(getOverrideGlobalStatusforloginUser.rejected, (state, action) => {
        state.overrideGlobalStatusUser = null;
        state.overrideGlobalStatusUserError = action.error.message;
      })
      .addCase(getPortalAdminRights.pending, (state) => {
        state.portalAdminRightsloading = true;
      })
      .addCase(getPortalAdminRights.fulfilled, (state, action) => {
        state.portalAdminRightsloading = false;
        state.portalAdminRights = action.payload;
        state.portalAdminRightserror = null;
      })
      .addCase(getPortalAdminRights.rejected, (state, action) => {
        state.portalAdminRightsloading = false;
        state.portalAdminRights = null;
        state.portalAdminRightserror = action.error.message;
      })
      .addCase(getOuAdminRights.pending, (state) => {
        state.ouAdminRightsloading = true;
      })
      .addCase(getOuAdminRights.fulfilled, (state, action) => {
        state.ouAdminRightsloading = false;
        state.ouAdminRights = action.payload;
        state.mailTemplateerror = null;
      })
      .addCase(getOuAdminRights.rejected, (state, action) => {
        state.ouAdminRightsloading = false;
        state.ouAdminRights = null;
        state.ouAdminRightserror = action.error.message;
      })
      .addCase(getDomainExportAttribute.pending, (state, action) => {
        state.domainExportAttributeLoader = true;
        state.domainExportAttributeData = [];
      })
      .addCase(getDomainExportAttribute.fulfilled, (state, action) => {
        state.domainExportAttributeLoader = false;
        state.domainExportAttributeData = action.payload.data.attributeNames;
      });
  },
});
export default settingsSlice.reducer;
